import { MoneyFormat } from "../MoneyFormat";

export const columnsArr = [
    {
        title: 'Spec No.',
        dataIndex: 'spec_concat',
        key: 'spec_concat',
        width: '130px',
    },
    {
        title: 'Card No.',
        dataIndex: 'card_no',
        key: 'card_no',
        width: '150px',
    },
    {
        title: 'Defect Count',
        dataIndex: 'defect_no',
        key: 'defect_no',
    },
    {
        title: 'Compliance Count',
        dataIndex: 'compliance_count',
        key: 'compliance_count',
    },
    {
        title: 'Raw Finding Rate',
        dataIndex: 'raw_findings_rate',
        key: 'raw_findings_rate',
        render: (ele) => {
            return ele.toFixed(3)
        },
    },
    {
        title: 'Total Effort Hours',
        dataIndex: 'total_effort_hours',
        key: 'total_effort_hours',
    },
    {
        title: 'Approx. life-time labor Cost ($)',
        dataIndex: 'total_labor_cost_max',
        key: 'total_labor_cost_max',
        render: ele => `${MoneyFormat(ele)}`,
    },
    {
        title: 'Yield %',
        dataIndex: 'yield_percentage',
        key: 'yield_percentage',
        width: '130px',

    },
    {
        title: 'Maintenance Check',
        dataIndex: 'mntc_check',
        key: 'mntc_check',
        width: '150px',

    },
    {
        title: 'Maintenance Check Interval',
        dataIndex: 'mntc_check_interval',
        key: 'mntc_check_interval',
        width: '200px',

    },
    {
        title: 'FEC',
        dataIndex: 'fec',
        key: 'fec',
    },




    {
        title: 'Rank Score',
        dataIndex: 'wpm_score',
        key: 'wpm_score',
        render: (ele) => {
            return ele.toFixed(3)
        },
    },
    {
        title: 'Rank',
        dataIndex: 'rank',
        key: 'rank',
    },
    {
        title: 'Spec Type',
        dataIndex: 'spec_type',
        key: 'spec_type"',
        align: 'center',
    },
    {
        title: 'Maintenance Check Package',
        dataIndex: 'mntc_check_package',
        width: '180px',
        key: 'mntc_check_package',

    },

    {
        title: 'Maintenance Check Package Interval ',
        dataIndex: 'mntc_check_package_interval',
        key: 'mntc_check_package_interval',

    },
    {
        title: 'Escalated Month',
        dataIndex: 'escalated_on',
        key: 'escalated_on',
        render: (ele) => {
            let strDate = ''
            if (ele) {
                strDate = new Date(ele)
            }
            return String(strDate).slice(4, 15)
        },
    },
    {
        title: 'Comments',
        dataIndex: 'comments',
        key: 'comments',
    },
    {
        title: 'Assigned To',
        dataIndex: 'assigned_to',
        key: 'assigned_to',
        width: '200px',
    },
];